import { IFilters } from '../../types/filters';

export function setQueryParamsFromFilters(filters: IFilters) {
  const url = new URL(window.location.href);

  const newLocation = filters.location?.toString() || null;
  const newSearchText = filters.searchText || null;
  const newSort = filters.sort || null;
  const newPage = filters.page?.toString() || null;

  if (newLocation) {
    url.searchParams.set('location', newLocation);
  } else {
    url.searchParams.delete('location');
  }

  if (newSearchText) {
    url.searchParams.set('search_text', newSearchText);
  } else {
    url.searchParams.delete('search_text');
  }

  if (newSort) {
    url.searchParams.set('sort', newSort);
  } else {
    url.searchParams.delete('sort');
  }

  if (newPage) {
    url.searchParams.set('p', newPage);
  } else {
    url.searchParams.delete('p');
  }

  return url;
}
